import styles from "./PolicyLabeledContent.module.css";

interface PolicyLabeledContentProps {
  label: string;
  text: string;
}

export default function PolicyLabeledContent({
  label,
  text,
}: PolicyLabeledContentProps): JSX.Element {
  return (
    <div className={styles.container}>
      <span className={styles.label}>{label}</span>
      <span className={styles.text}>{text}</span>
    </div>
  );
}
